import React from 'react'

import Store from 'store'

import { CallbackWrap } from '@/types/common'
import { LinkEmbed } from '@/types/embed'
import { Gem } from '@/types/item'
import classNames from 'classnames'
import { CopyEmbedBox } from 'components/copy'
import Data from 'data'
import { getGemColor } from 'logic/mods'
import { WithGemTooltip } from 'tooltip'
import { GemEditor } from './SkillEditor'

function LinkGem({ index }: { index: number }) {
  const data = Store.useEmbed((embed) => (embed as LinkEmbed).gems[index])
  const dispatch = Store.useDispatch()
  const onChange = React.useCallback(
    (value: CallbackWrap<Gem | undefined>) =>
      dispatch.setEmbed((embed) => {
        if (embed.type !== 'link') return embed
        const prev = embed.gems[index]
        if (typeof value === 'function') value = value(prev)
        if (value === prev) return embed
        embed = { ...embed }
        embed.gems = embed.gems.slice()
        if (value) {
          embed.gems[index] = value
        } else {
          embed.gems.splice(index, 1)
        }
        return embed
      }),
    [dispatch, index]
  )

  return <GemEditor gem={data} onChange={onChange} />
}

function LinkEmbedGem({ gem }: { gem: Gem }) {
  if (!gem) return null
  const data = Data.gems[gem.id]
  if (!data) return null
  const color = getGemColor(data)
  return (
    <div
      className={classNames(
        `poe-SocketImage poe-socket-${color} poe-gem-${color}`,
        { 'poe-socket-support': data && data.is_support }
      )}>
      <WithGemTooltip gem={gem}>
        <div className="poe-image" />
      </WithGemTooltip>
      <div className="poe-socket-link poe-active" />
    </div>
  )
}

export function LinkEmbedView({ embed }: { embed: LinkEmbed }) {
  const rows = [...Array(Math.ceil(embed.gems.length / 2))].map((_, i) =>
    embed.gems.slice(i * 2, i * 2 + 2)
  )
  return (
    <div className="poe-LinkView">
      {rows.map((row, i) => (
        <div key={i} className="poe-SocketRow">
          {row.map((gem, i) => (
            <LinkEmbedGem key={i} gem={gem} />
          ))}
        </div>
      ))}
    </div>
  )
}

export default function LinkEditor() {
  const embed = Store.useEmbed() as LinkEmbed
  return (
    <div className="poe-SkillEditor poe-LinkEditor">
      <div className="poe-skill-container">
        <LinkEmbedView embed={embed} />
        <CopyEmbedBox type="link" />
      </div>
      <div className="poe-editor">
        <div>
          {embed.gems.map((_, gid) => (
            <LinkGem key={gid} index={gid} />
          ))}
          <LinkGem index={embed.gems.length} />
        </div>
      </div>
    </div>
  )
}
